<template>
  <section class="slot-allgame xs-section">
    <div class="allgame-inner">
      <div class="allgame-box">
        <!-- <div class="title-box">
          <div class="allgame-title">
          <h3>All Games</h3>
          </div>
          <div class="game-etc">
            <v-btn
              class="favorite-filter"
              elevation="0"
              :class="isFilteredFavorite ? 'active' : ''"
              @click="toggleFavorite"
            >
              <v-icon></v-icon>
              {{ $t("allGames.favorites") }}</v-btn
            >
            <v-btn class="quick-join" elevation="0">
              <v-icon></v-icon>
              Quick Join</v-btn
            >
          </div>
        </div> -->
        <div class="main-games">
          <ul id="hot_games" class="main-game-lists">
            <li
              class="main-game-list hot"
              v-for="item in getFilteredMachineList"
              :key="item.id"
            >
              <div
                class="main-game-box"
                :class="item.status === 2 ? 'use' : ''"
              >
                <div class="main-game-img hot" @click="handleGame(item)">
                  <div class="click-img">
                    <div class="game-img">
                      <img
                        :src="getRoadMap(item.id)"
                        :style="{
                          transform: 'scaleX(-1)',
                          objectFit: 'contain',
                          objectPosition: 'top center',
                          backgroundColor: '#000000',
                        }"
                        alt="hotgame1"
                      />

                      <div :style="{ position: 'relative', top: '-22px' }">
                        <v-row :style="{ margin: 0 }">
                          <label class="rtpLabel" :style="{ color: '#FFFFFF' }"
                            >Live RTP:
                          </label>
                          <v-spacer></v-spacer>
                          <label class="rtpLabel" :style="{ color: '#30FF00' }"
                            >{{ getLiveRTP(item.id) }} %</label
                          >
                        </v-row>
                      </div>
                    </div>
                    <div class="game-img" v-if="item.imagePath !== null">
                      <img :src="item.imagePath" alt="hotgame1" />
                    </div>
                  </div>
                  <div class="game-info">
                    <div class="game-state">
                      <p
                        class="state"
                        :class="[
                          {
                            disabled: item.status == 0,
                            idle: item.status == 2,
                            disuse:
                              item.status == 1 ||
                              item.status === 3 ||
                              item.status === 4,
                          },
                        ]"
                      >
                        {{ machineState(item.status) }}
                      </p>
                    </div>
                    <div class="machine-num">
                      <p class="machine-id">
                        {{ item.gameId.slice(0, 2) }}#{{ item.number }}
                      </p>
                    </div>
                  </div>

                  <div class="state-filter">
                    <div class="use-state watch" v-if="item.status == 2">
                      <div class="machine-logo">
                        <img :src="item.gameImage" :alt="item.gameId" />
                      </div>
                      <v-btn class="watch-btn play">
                        <v-icon></v-icon>
                        <span>{{ $t("machineStatus.playNow") }}</span>
                      </v-btn>
                    </div>
                    <div class="use-state watch" v-else-if="item.status == 3">
                      <div class="machine-logo">
                        <img :src="item.gameImage" :alt="item.gameId" />
                      </div>
                      <v-btn class="watch-btn">
                        <v-icon></v-icon>
                        <span>{{ $t("machineStatus.watching") }}</span>
                      </v-btn>
                    </div>
                    <div class="use-state" v-else-if="item.status == 4">
                      <img src="@assets/img/main/locked-icon.png" alt="" />
                      <p class="state">{{ $t("machineStatus.locked") }}</p>
                    </div>
                    <div class="use-state" v-else>
                      <img src="@assets/img/state-icon.png" alt="" />
                      <p class="state">{{ $t("machineStatus.maintenance") }}</p>
                    </div>
                  </div>
                </div>
                <div class="main-game-title hot">
                  <p>{{ item.name ? item.name : "-" }}</p>
                  <div class="like-icon" v-if="getLoginCheck" @click="handleLike(item)">
                    <i
                      id="heart"
                      class="heart-icon"
                      :class="item.isFavorite ? 'active' : ''"
                    ></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <!-- <PlayViewDialog
      ></PlayViewDialog> -->
    </div>
  </section>
</template>
<script>
import { AuthActions, AuthNamespace } from "@/store/auth";
import {
  MachineActions,
  MachineMutations,
  MachineNamespace,
} from "@/store/machine";
import { MACHINE_STATE } from "@/utils/machineState";
import { mapActions, mapGetters, mapMutations } from "vuex";

import EventBus from "@/utils/EventBus";

import { HubConnectionState } from "@microsoft/signalr";

import { RoadMapDataParse } from "@/utils//RoadMapDataParse.js";

import globalMixin from "@/mixins/globalMixin";

export default {
  mixins: [globalMixin],
  data() {
    return {
      slotGames: [
        {
          title: "Luxury 50 Lions",
          url: "slotgame_img00.png",
        },
        {
          title: "Double Money Link",
          url: "slotgame_img01.png",
        },
        {
          title: "5 Dragons Ultra",
          url: "slotgame_img02.png",
        },
        {
          title: "Coin Combo",
          url: "slotgame_img03.png",
        },
        {
          title: "Fu Dai Lian Lain",
          url: "slotgame_img04.png",
        },
      ],
      // notifyDialog: false,
      notifyMessage: null,
      // isFavorite: false, // ?꾪꽣 諛뺤뒪 利먭꺼李얘린 ?좉? ?곹깭
      roadMapDataParse: new RoadMapDataParse(),
    };
  },
  watch: {
    selectedJackpotId(newId, oldId) {
      if (newId !== oldId) {
        // 寃뚯엫 ?뚮쭏 珥덇린??
        this.updateSelectedTheme("all");
      }
    },
  },
  mounted() {
    // ??議곗씤 踰꾪듉 ?대깽??由ъ뒪??
    EventBus.$on("quickJoinGame", this.quickJoinGame);

    if (this.getMachineConnectionState) {
      this.MUTATION_MACHINE_KICK_OFF(false);
      this.showNotifyDialog({
        title: this.$t("notifyMessage.title"),
        text: this.$t("notifyMessage.text"),
        btnText: this.$t("button.confirm"),
      });
    }

    // 癒몄떊 由ъ뒪??議고쉶 ?붿껌
    this.loadMachineList();
  },

  computed: {
    ...mapGetters(AuthNamespace, [
      "getExternalToken",
      "getPlayerId",
      "getLoginCheck",
    ]),

    ...mapGetters(MachineNamespace, [
      "getMachineList",
      "getRoadMapList",
      "getMachineId",
      "getMachineConnectionState",
    ]),

    machineState() {
      return (state) => {
        let result = "";
        switch (state) {
          case MACHINE_STATE.IDLE:
            // ?ъ슜媛??
            result = this.$t("machineStatus.idle");
            break;
          case MACHINE_STATE.USING:
            // ?ъ슜以?
            result = this.$t("machineStatus.occupied");
            break;
          case MACHINE_STATE.DISABLED:
            // ?ъ슜遺덇?
            result = this.$t("machineStatus.maintenance");
            break;
          case MACHINE_STATE.PREPARING:
            // 以鍮꾩쨷
            result = this.$t("machineStatus.preparing");
            break;
          case MACHINE_STATE.Locked:
            // ?좉?
            result = this.$t("machineStatus.locked");
            break;
          default:
            break;
        }
        return result;
      };
    },

    // // ?꾪꽣留곷맂 癒몄떊 紐⑸줉
    // filteredList() {
    //   let filteredList = this.getMachineList;

    //   // ?좏깮???뚮쭏???곕Ⅸ ?꾪꽣留?
    //   if (this.getSelectedTheme !== "all") {
    //     filteredList = filteredList.filter(
    //       (machine) => machine.gameId === this.getSelectedTheme,
    //     );
    //   }

    //   if (this.getSelectedJackpotId !== "all") {
    //     filteredList = filteredList.filter(
    //       (machine) => machine.jackpotId === this.getSelectedJackpotId,
    //     );
    //   }

    //   // 利먭꺼李얘린 ?꾪꽣留?
    //   if (this.getIsFilteredFavorite) {
    //     filteredList = filteredList.filter(
    //       (machine) => machine.isFavorite === true,
    //     );
    //   }
    //   return filteredList;
    // },
  },
  methods: {
    ...mapMutations(MachineNamespace, {
      MUTATION_MACHINE_KICK_OFF: MachineMutations.MUTATION_MACHINE_KICK_OFF,
    }),

    ...mapActions(AuthNamespace, {
      ACTION_AUTH_LOGIN: AuthActions.ACTION_AUTH_LOGIN,
      ACTION_AUTH_LOGOUT: AuthActions.ACTION_AUTH_LOGOUT,
    }),

    ...mapActions(MachineNamespace, {
      ...MachineActions,
    }),

    loadMachineList() {
      this.ACTION_READ_MACHINE_LIST({
        playerId: this.getPlayerId,
      }).then(() => {
        // 癒몄떊 由ъ뒪?몃? 遺紐?而댄룷?뚰듃濡?emit
        // this.$emit("updateMachineList", this.getMachineList);
        this.handleFilteredMachines(this.getMachineList);
        if (
          this.getMachineList.length > 0 &&
          this.$machineHub.hub.state === HubConnectionState.Connected
        ) {
          // 癒몄떊 id 以묐났 ?쒓굅
          const machine_id_list = new Set(
            this.getMachineList.map((m) => {
              return m.machine_id;
            })
          );
          const filter_list = [...machine_id_list];

          // 癒몄떊 id ?곹깭 ?붿껌
          for (const id of filter_list) {
            if (id !== null) {
              this.$machineHub.hub.invoke("UsingStatus", id);
            }
          }
        }
      });
    },

    // 利먭꺼李얘린 異붽?/?댁젣
    handleLike(item) {
      if (this.getPlayerId !== undefined) {
        const data = {
          player_id: this.getPlayerId,
          machine_id: item.id,
        };

        if (item.isFavorite) {
          this.ACTION_DELETE_MACHINE_FAVORITE(data).then(() => {
            item.isFavorite = false;
          });
        } else {
          this.ACTION_CREATE_MACHINE_FAVORITE(data).then(() => {
            item.isFavorite = true;
          });
        }
      }
    },

    handleShow(index) {
      this.getMachineList[index].isShow = !this.getMachineList[index].isShow;
    },
    // 寃뚯엫 癒몄떊 ?좏깮 ?대깽??
    async handleGame(machine) {
      if (machine.status === MACHINE_STATE.DISABLED) return;

      //寃뚯엫愿??
      if (machine.status === MACHINE_STATE.USING) {
        // 濡쒓렇???곹깭媛 ?꾨땶寃쎌슦
        if (!this.getLoginCheck) {
          this.$cookies.set("direct_playView", machine.id, 60 * 10);
          this.openSignInDialog();
          return;
        }
        this.setPlayViewMachine(machine);
        this.ACTION_READ_MACHINE_GAME_TYPE(machine.id);
        this.setDialog("playView", true);
        return;
      }

      //寃뚯엫?뚮젅??
      if (machine.status === MACHINE_STATE.IDLE) {
        // 濡쒓렇???곹깭媛 ?꾨땶寃쎌슦
        if (!this.getLoginCheck) {
          this.$cookies.set("direct_game", machine.id, 60 * 10);
          this.openSignInDialog();
          return;
        }

        // 寃뚯엫 ?섏씠吏?댁뿉???대룞
        if (window.location.pathname === "/game") {
          // ?좏깮??癒몄떊怨??꾩옱 ?ъ슜以묒씤 癒몄떊 id媛 媛숈? 寃쎌슦
          if (this.getMachineId === machine.id) {
            return;
          }
          // Emit 硫붿떆吏 諛쒖넚
          this.$emit("moveGameEvent", machine.id);
        }
        // 硫붿씤?섏씠吏?먯꽌 ?대룞
        else {
          // ?좏깮??癒몄떊???ъ슜???뺣낫 ?깅줉
          if (this.$device.mobile) {
            EventBus.$emit("directionSelect/machine_id", machine.id);
            this.setDialog("directionSelect", true);
          } else {
            this.createMachinePlayer(machine.id);
          }
        }
      }
    },

    openSignInDialog() {
      this.setDialog("signIn", true);
    },
    closeNotifyDialog() {
      this.setDialog("notify", false);
      if (window.location.pathname === "/game") this.$router.replace("");
      if (this.getMachineConnectionState) {
        this.MUTATION_MACHINE_KICK_OFF(false);
      }
    },

    // ??議곗씤 踰꾪듉 ?대깽??
    quickJoinGame() {
      this.handleGame(this.getMachineList[0]);
    },

    getRoadMap(machineId) {
      return this.roadMapDataParse.MakeRoadMapImage(machineId);
    },

    getLiveRTP(machineId) {
      const findIndex = this.getRoadMapList.findIndex(
        (e) => e.machineId === machineId
      );
      if (findIndex !== -1) {
        return this.getRoadMapList[findIndex].liveRTP;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style>
.rtpLabel {
  font-size: 13px;
  font-weight: 700;
  text-shadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000";
}
</style>

